import _getIterator from 'babel-runtime/core-js/get-iterator';
import _extends from 'babel-runtime/helpers/extends';

import SlideView from '@/components/SlideView';
import xss from 'xss';
import { workTaskArchiveAPI, workTaskRecoverAPI // 激活任务
} from '@/api/pm/task';
import { deleteTaskRelationAPI, editTaskRelationAPI, detailsTaskAPI, detailsTrashTaskAPI, queryLogTaskAPI } from '@/api/task/task';
import { deleteCommentAPI, setCommentAPI } from '@/api/oa/common';
import { workTaskStatusSetAPI, workTaskChildStatusSetAPI, workTaskTitleSetAPI, workTaskDescriptionSetAPI, workTaskMainUserSetAPI, workTaskTimeSetAPI, workTaskOwnerUserSetAPI, workTaskOwnerUserDeleteAPI, workTaskPrioritySetAPI, workTaskDeleteAPI, workSubTaskDeleteAPI } from '@/api/pm/projectTask';
// 项目参与人
import { workWorkOwnerListAPI } from '@/api/pm/project';
import { workTrashRecoverAPI, workTrashDeleteAPI } from '@/api/pm/recycle';

import MembersDep from '@/components/SelectEmployee/MembersDep';
import TagIndex from './Tag/TagIndex';
import SubTask from './SubTask';

// emoji
import Emoji from '@/components/Emoji';
// 相关信息 - 选中列表
import RelatedBusiness from '@/components/RelatedBusiness';
import { XhUserCell } from '@/components/CreateCom';
import FileCell from '@/views/oa/components/FileCell';
import { mapGetters } from 'vuex';
import CommentList from '@/components/CommentList';
import ReplyComment from '@/components/ReplyComment';
import moment from 'moment';
import { objDeepCopy } from '@/utils';
import TaskMixin from '../mixins/TaskMixin';

export default {
  name: 'TaskDetail',
  components: {
    SlideView: SlideView,
    MembersDep: MembersDep,
    Emoji: Emoji,
    RelatedBusiness: RelatedBusiness,
    TagIndex: TagIndex,
    CRMFullScreenDetail: function CRMFullScreenDetail() {
      return import('@/components/CRMFullScreenDetail');
    },
    SubTask: SubTask,
    FileCell: FileCell,
    XhUserCell: XhUserCell,
    CommentList: CommentList,
    ReplyComment: ReplyComment
  },
  mixins: [TaskMixin],
  props: {
    id: [String, Number],
    isTrash: Boolean,
    detailIndex: Number,
    detailSection: Number,
    noListenerClass: {
      type: Array,
      default: function _default() {
        return ['el-table__body'];
      }
    }
  },
  data: function data() {
    var _this = this;

    return {
      loading: null,
      canShowDetail: true,
      // 紧急弹出框
      priorityVisible: false,

      /**
      * 限制时间选择`
      */
      startTimeOptions: {
        disabledDate: function disabledDate(time) {
          if (!_this.taskData || !_this.taskData.stop_time) {
            return false;
          }
          return moment(time).isAfter(_this.taskData.stop_time);
        }
      },
      stopTimeOptions: {
        disabledDate: function disabledDate(time) {
          if (!_this.taskData || !_this.taskData.start_time) {
            return false;
          }
          return moment(time).isBefore(_this.taskData.start_time);
        }
      },
      // 是否显示子任务
      addSubtasks: true,
      // 任务名称和编辑切换
      nameVinput: false,
      // 任务名
      taskDataName: '',
      // 是否显示描述
      addDescriptionShow: false,
      // 描述内容
      addDescriptionTextarea: '',
      // 子任务进度
      subTaskComplete: 0,
      // 是否显示评论框
      addComments: false,
      allData: {},
      commentsLoading: false,
      // 相关详情的查看
      relatedID: '',
      relatedCRMType: '',
      showRelatedDetail: false,
      // 子任务ID
      subTaskID: null,
      // 任务详情
      taskData: null,
      activityList: [],
      fileList: [],
      // 评论列表
      replyList: []
    };
  },

  computed: _extends({}, mapGetters(['userInfo']), {
    priority: function priority() {
      if (this.taskData.priority == 0 || !this.taskData.priority) {
        return this.priorityList[3]; // 默认读取 priorityList 返回
      }
      return this.getPriorityColor(this.taskData.priority);
    },


    /**
     * 是归档
     */
    isArchive: function isArchive() {
      return this.taskData.is_archive == 1 && this.taskData.ishidden != 1;
    },


    /**
     * 是回收站
     */
    isRecycle: function isRecycle() {
      return this.taskData.ishidden == 1;
    },


    /**
     * 展示归档
     */
    showArchiveBtn: function showArchiveBtn() {
      return this.workId && !this.isArchive && !this.isRecycle;
    },


    /**
     * 子任务完成进度
     */
    subTaskProgress: function subTaskProgress() {
      if (this.subTaskComplete == 0) {
        return 0;
      }
      return parseInt(this.subTaskComplete / this.taskData.subTaskList.length * 100);
    },
    ownerListRequest: function ownerListRequest() {
      return this.workId ? workWorkOwnerListAPI : null;
    },
    ownerListParams: function ownerListParams() {
      return this.workId ? { work_id: this.workId } : null;
    },


    /**
     * 项目ID 说明是项目
     */
    workId: function workId() {
      return this.taskData && this.taskData.work_id;
    },


    /**
     * 标签
     */
    labelList: function labelList() {
      if (!this.taskData) {
        return null;
      }
      return this.taskData.lable_list || [];
    }
  }),
  watch: {
    id: function id(val) {
      this.initInfo();
      this.getDetail();
      this.getCommentList();
      this.getActivityList();
    },

    labelList: function labelList(newValue, oldValue) {
      if (oldValue && newValue) {
        this.$emit('on-handle', {
          type: 'change-label',
          value: newValue,
          index: this.detailIndex,
          section: this.detailSection
        });
      }
    },
    addDescriptionTextarea: function addDescriptionTextarea(val) {
      this.$refs.sideView.isEditClose = !!(val && val.length > 0);
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},

  methods: {
    /**
     * 动画完成方法
     */
    viewAfterEnter: function viewAfterEnter() {
      if (this.id) {
        this.getDetail();
        this.getCommentList();
        this.getActivityList();
      }
    },
    initInfo: function initInfo() {
      this.taskData = null;
      this.subTaskComplete = 0;
      this.addDescriptionShow = false;
      this.priorityVisible = false;
      this.addSubtasks = true;
      this.nameVinput = false;
      this.addDescriptionTextarea = '';
      this.addComments = false;
      // 设置关联项列表
      this.allData = {
        business: [],
        contacts: [],
        contract: [],
        customer: []
      };

      this.relatedID = '';
      this.showRelatedDetail = false;

      this.activityList = [];
      this.fileList = [];
      this.replyList = [];
    },


    /**
     * 详情
     */
    getDetail: function getDetail() {
      var _this2 = this;

      this.loading = true;
      var request = this.isTrash ? detailsTrashTaskAPI : detailsTaskAPI;
      request({ task_id: this.id }).then(function (res) {
        var taskData = res.data;
        taskData.checked = taskData.status == 5;

        if (taskData.subTaskList) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = _getIterator(taskData.subTaskList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              if (item.status == 5) {
                item.checked = true;
                _this2.subTaskComplete++;
              } else {
                item.checked = false;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
        _this2.fileList = taskData.fileList || [];

        _this2.allData = {
          business: (taskData.businessList || []).map(function (item) {
            if (item.id) {
              item.businessId = item.id;
            }
            return item;
          }),
          contacts: (taskData.contactsList || []).map(function (item) {
            if (item.id) {
              item.contactsId = item.id;
            }
            return item;
          }),
          contract: (taskData.contractList || []).map(function (item) {
            if (item.id) {
              item.contractId = item.id;
            }
            return item;
          }),
          customer: (taskData.customerList || []).map(function (item) {
            if (item.id) {
              item.customerId = item.id;
            }
            return item;
          })
        };
        _this2.getCommentList(taskData.replyList);
        _this2.taskData = taskData;
        _this2.loading = false;
      }).catch(function (error) {
        _this2.loading = false;
        if (error && error.msg == '没有权限') {
          _this2.canShowDetail = false;
        } else {
          _this2.closeBtn();
        }
      });
    },


    /**
     * 活动信息
     */
    getActivityList: function getActivityList() {
      var _this3 = this;

      queryLogTaskAPI({
        task_id: this.id,
        work_id: this.workId
      }).then(function (res) {
        _this3.activityList = res.data;
      }).catch(function () {});
    },


    /**
     * 评论信息
     */
    getCommentList: function getCommentList(replyList) {
      // queryCommentListAPI({
      //   type_id: this.id,
      //   type: 1 // 1是任务 2 是日志
      // })
      //   .then(res => {
      //     this.replyList = res.data
      //   })
      //   .catch(() => {})
      this.replyList = replyList || [];
    },


    /**
     * 完成任务
     */
    completeMainTask: function completeMainTask(val) {
      var _this4 = this;

      this.taskData.checked = val;
      workTaskStatusSetAPI({
        work_id: this.workId,
        task_id: this.id,
        status: this.taskData.checked ? 5 : 1
      }).then(function (res) {
        _this4.$emit('on-handle', {
          type: 'title-check',
          value: val,
          index: _this4.detailIndex,
          section: _this4.detailSection
        });
        // this.$store.dispatch('GetOAMessageNum', 'task')
      }).catch(function () {
        // this.$emit('on-handle', {
        //   type: 'title-check',
        //   value: !this.taskData.checked,
        //   index: this.detailIndex,
        //   section: this.detailSection
        // })
        _this4.taskData.checked = !_this4.taskData.checked;
      });
    },


    /**
     * 编辑任务标题
     */
    editTaskName: function editTaskName() {
      if (this.getPermission('setTaskTitle')) {
        this.nameVinput = true;
        this.taskDataName = this.taskData.name;
      }
    },


    /**
     * 编辑任务描述
     */
    editTaskDescription: function editTaskDescription() {
      if (this.getPermission('setTaskDescription')) {
        this.addDescriptionShow = true;
        this.addDescriptionTextarea = this.taskData.description;
      }
    },


    /**
     * 获取权限
     */
    getPermission: function getPermission(key) {
      if (!this.workId) {
        return true;
      }

      var permission = this.taskData ? this.taskData.auth || {} : {};
      return !!permission[key];
    },


    /**
     * 关闭
     */
    closeBtn: function closeBtn() {
      this.$emit('close');
    },


    /**
     * 紧急按钮
     */
    priorityBtn: function priorityBtn(value, def) {
      var _this5 = this;

      this.taskData.priority = value.id;
      workTaskPrioritySetAPI({
        work_id: this.workId,
        task_id: this.id,
        priority_id: value.id
      }).then(function (res) {
        _this5.$emit('on-handle', {
          type: 'change-priority',
          value: value,
          index: _this5.detailIndex,
          section: _this5.detailSection
        });
        _this5.priorityVisible = false;
      }).catch(function () {
        _this5.$message.error('编辑失败');
        _this5.taskData.priority = def;
      });
    },

    // 更多 ———— 删除和规定按钮
    moreDelete: function moreDelete() {
      var _this6 = this;

      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'is-particulars'
      }).then(function () {
        workTaskDeleteAPI({ task_id: _this6.id, work_id: _this6.workId }).then(function (res) {
          _this6.$message.success('删除成功');
          _this6.$emit('on-handle', {
            type: 'delete',
            index: _this6.detailIndex,
            section: _this6.detailSection
          });
          _this6.$emit('close');
        }).catch(function () {});
      }).catch(function () {
        _this6.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    moreArchive: function moreArchive() {
      var _this7 = this;

      this.$confirm('此操作将归档该任务, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'is-particulars'
      }).then(function () {
        workTaskArchiveAPI({ task_id: _this7.id, work_id: _this7.workId }).then(function (res) {
          _this7.$message.success('操作成功');
          _this7.$emit('on-handle', {
            type: 'delete',
            index: _this7.detailIndex,
            section: _this7.detailSection
          });
          _this7.$emit('close');
        }).catch(function () {});
      }).catch(function () {
        _this7.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    // 附件 -- 上传
    httpRequest: function httpRequest(val) {
      var _this8 = this;

      this.$wkUploadFile.upload({
        file: val.file,
        params: {
          work_id: this.workId,
          type: 'file',
          module: 'work_task',
          module_id: this.id,
          batchId: this.taskData.batchId
        }
      }).then(function (_ref) {
        var res = _ref.res;

        var data = res.data || {};
        _this8.fileList.push(data);
        // this.$emit('httpRequest', this.taskData)
        _this8.$message.success('上传成功');
      }).catch(function () {});
    },

    // 附件删除
    accessoryDeleteFun: function accessoryDeleteFun(index, item) {
      this.fileList.splice(index, 1);
    },

    // 子任务 -- 勾选
    subtasksCheckbox: function subtasksCheckbox(val, e) {
      var _this9 = this;

      if (e) {
        this.$set(val, 'checked', true);
        this.subTaskComplete++;
      } else {
        this.$set(val, 'checked', false);
        this.subTaskComplete--;
      }
      // this.$emit('on-handle', {
      //   type: 'change-sub-task',
      //   value: {
      //     subdonecount: this.subTaskComplete,
      //     allcount: this.taskData.subTaskList.length
      //   },
      //   index: this.detailIndex,
      //   section: this.detailSection
      // })

      workTaskChildStatusSetAPI({
        work_id: this.workId,
        task_id: val.task_id,
        status: e ? 5 : 1
      }).then(function (res) {
        _this9.$emit('on-handle', {
          type: 'change-sub-task',
          value: {
            subdonecount: _this9.subTaskComplete,
            allcount: _this9.taskData.subTaskList.length
          },
          index: _this9.detailIndex,
          section: _this9.detailSection
        });
      }).catch(function () {
        _this9.$message.error('子任务标记失败');
        if (e) {
          _this9.$set(val, 'checked', false);
          _this9.subTaskComplete--;
        } else {
          _this9.$set(val, 'checked', true);
          _this9.subTaskComplete++;
        }
        // this.$emit('on-handle', {
        //   type: 'change-sub-task',
        //   value: {
        //     subdonecount: this.subTaskComplete,
        //     allcount: this.taskData.subTaskList.length
        //   },
        //   index: this.detailIndex,
        //   section: this.detailSection
        // })
        // this.$emit('', val, e)
      });
    },

    /**
     * 参与人操作
     */
    editOwnerList: function editOwnerList(users, dep) {
      var _this10 = this;

      workTaskOwnerUserSetAPI({
        work_id: this.workId,
        task_id: this.id,
        owner_userids: users.map(function (item) {
          return item.id;
        }).join(',')
      }).then(function (res) {
        _this10.taskData.owner_list = users;
      }).catch(function () {});
    },


    /**
     * 参与人删除按钮
     */
    deleteOwnerList: function deleteOwnerList(item, index) {
      var _this11 = this;

      workTaskOwnerUserDeleteAPI({
        work_id: this.workId,
        task_id: this.id,
        owner_userid_del: item.id,
        type: 'owner_userid_del'
      }).then(function (res) {
        _this11.taskData.owner_list.splice(index, 1);
      }).catch(function () {});
    },


    /**
     * 编辑负责人
     */
    mainUserChange: function mainUserChange(data) {
      var main_user = data.value.length > 0 ? data.value[0] : null;
      this.submiteMainUser(main_user);
    },


    /**
     * 上传负责人信息
     */
    submiteMainUser: function submiteMainUser(main_user) {
      var _this12 = this;

      workTaskMainUserSetAPI({
        work_id: this.workId,
        task_id: this.id,
        main_user_id: main_user ? main_user.id : '',
        type: 'main_user_id'
      }).then(function (res) {
        if (main_user) {
          _this12.$set(_this12.taskData, 'main_user', main_user);
        } else {
          _this12.$set(_this12.taskData, 'main_user', null);
        }

        _this12.$emit('on-handle', {
          type: 'change-main-user',
          value: main_user,
          index: _this12.detailIndex,
          section: _this12.detailSection
        });
      }).catch(function () {});
    },


    /**
     * 编辑任务名
     */
    submiteTaskName: function submiteTaskName(val) {
      var _this13 = this;

      workTaskTitleSetAPI({
        work_id: this.workId,
        name: val,
        type: 'name',
        task_id: this.id
      }).then(function (res) {
        _this13.nameVinput = false;
        // this.$emit('saveName', val)
        _this13.$emit('on-handle', {
          type: 'change-name',
          value: val,
          index: _this13.detailIndex,
          section: _this13.detailSection
        });
        _this13.taskData.name = val;
      }).catch(function () {});
    },


    /**
     * 截至日期API
     */
    deleteTime: function deleteTime(type) {
      this.taskData[type] = '';
      this.timeChange(type);
    },
    timeChange: function timeChange(type) {
      var _this14 = this;

      var params = { task_id: this.id, type: type, work_id: this.workId };
      params[type] = this.taskData[type];
      workTaskTimeSetAPI(params).then(function (res) {
        // 停止时间回调
        if (type == 'stop_time') {
          _this14.$emit('on-handle', {
            type: 'change-stop-time',
            value: _this14.taskData[type],
            index: _this14.detailIndex,
            section: _this14.detailSection
          });
        }
      }).catch(function () {});
    },


    /**
     * 描述提交按钮
     */
    submiteDescription: function submiteDescription() {
      var _this15 = this;

      workTaskDescriptionSetAPI({
        work_id: this.workId,
        task_id: this.id,
        description: this.addDescriptionTextarea
      }).then(function (res) {
        _this15.addDescriptionShow = false;
        _this15.$set(_this15.taskData, 'description', _this15.addDescriptionTextarea);
        _this15.addDescriptionTextarea = '';
      }).catch(function () {});
    },


    /**
     * 评论发布
     */
    handleReply: function handleReply(data) {
      var _this16 = this;

      if (data) {
        this.commentsLoading = true;

        setCommentAPI({
          // task_id: this.id,
          work_id: this.workId,
          type_id: this.id,
          type: 1,
          content: xss(data)
        }).then(function (res) {
          res.data.childCommentList = [];
          res.data.user = {
            userId: _this16.userInfo.id,
            realname: _this16.userInfo.realname,
            img: _this16.userInfo.img
          };
          _this16.$refs.f_reply.commentsTextarea = '';
          _this16.replyList.push(res.data);
          _this16.$emit('on-handle', {
            type: 'change-comments',
            value: 'add',
            index: _this16.detailIndex,
            section: _this16.detailSection
          });
          _this16.commentsLoading = false;
        }).catch(function () {
          _this16.commentsLoading = false;
        });
      }
    },
    deleteComment: function deleteComment(index) {
      this.replyList.splice(index, 1);
    },


    // 删除评论
    discussDelete: function discussDelete(val, items, index) {
      var _this17 = this;

      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'is-particulars'
      }).then(function () {
        deleteCommentAPI({
          work_id: _this17.workId,
          comment_id: val.comment_id,
          task_id: _this17.id
        }).then(function (res) {
          items.splice(index, 1);
          _this17.$emit('on-handle', {
            type: 'change-comments',
            value: 'delete',
            index: _this17.detailIndex,
            section: _this17.detailSection
          });
        }).catch(function () {});
      }).catch(function () {
        _this17.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },


    // 相关信息提交按钮
    checkInfos: function checkInfos(val, alldata) {
      var _this18 = this;

      editTaskRelationAPI({
        work_id: this.taskData.work_id,
        task_id: this.id,
        customer_ids: val.customerIds && val.customerIds.length ? val.customerIds : [],
        contacts_ids: val.contactsIds && val.contactsIds.length ? val.contactsIds : [],
        business_ids: val.businessIds && val.businessIds.length ? val.businessIds : [],
        contract_ids: val.contractIds && val.contractIds.length ? val.contractIds : []
      }).then(function (res) {
        _this18.$message.success('关联成功');
        _this18.allData = alldata;
        _this18.$emit('on-handle', {
          type: 'relation-business',
          index: _this18.detailIndex,
          section: _this18.detailSection
        });
      }).catch(function () {});
    },


    /**
     * 解绑详情信息
     */
    unbindRelatedInfo: function unbindRelatedInfo(field, item, index) {
      var _this19 = this;

      this.$confirm('确认取消关联?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'is-particulars'
      }).then(function () {
        var params = {
          work_id: _this19.workId,
          task_id: _this19.taskData.task_id,
          id: item[field + '_id'],
          type: {
            'customer': 1,
            'contacts': 2,
            'business': 3,
            'contract': 4
          }[field]
        };
        var tempRelatedListData = objDeepCopy(_this19.allData);
        tempRelatedListData[field].splice(index, 1);
        // const showTypes = ['customer', 'contacts', 'business', 'contract']
        // for (let index = 0; index < showTypes.length; index++) {
        //   const typeItem = showTypes[index]
        //   const typeArray = tempRelatedListData[typeItem] || []
        //   params[typeItem + 'Ids'] = typeArray
        //     .map(aItem => {
        //       return aItem[typeItem + 'Id']
        //     })
        //     .join(',')
        // }
        deleteTaskRelationAPI(params).then(function (res) {
          _this19.allData = tempRelatedListData;
          _this19.$message.success('关联取消成功');
        }).catch(function () {});
      }).catch(function () {
        _this19.$message.info('已取消操作');
      });
    },


    /**
     * 查看相关详情
     */
    checkRelatedDetail: function checkRelatedDetail(crmType, item) {
      this.relatedID = item[crmType + '_id'];
      this.relatedCRMType = crmType;
      this.showRelatedDetail = true;
    },


    /**
     * 删除任务
     */
    deleteSubTask: function deleteSubTask(val) {
      var _this20 = this;

      this.$confirm('此操作将删除该任务, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'is-particulars'
      }).then(function () {
        workSubTaskDeleteAPI({ task_id: val.task_id, work_id: _this20.workId }).then(function (res) {
          var subData = _this20.taskData.subTaskList;
          for (var i in subData) {
            if (subData[i].task_id == val.task_id) {
              subData.splice(i, 1);
              break;
            }
          }
          if (val.checked) {
            _this20.subTaskComplete--;
          }

          _this20.$emit('on-handle', {
            type: 'change-sub-task',
            value: {
              subdonecount: _this20.subTaskComplete,
              allcount: _this20.taskData.subTaskList.length
            },
            index: _this20.detailIndex,
            section: _this20.detailSection
          });
          _this20.$message.success('子任务删除成功');
        }).catch(function () {
          _this20.$message.error('子任务删除失败');
        });
      }).catch(function () {
        _this20.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },


    /**
     * 编辑子任务
     */
    editSubTask: function editSubTask(val) {
      this.subTaskID = val.task_id;
      var dataList = this.taskData.subTaskList;
      for (var i in dataList) {
        if (dataList[i].task_id == val.task_id) {
          this.$set(dataList[i], 'showEdit', true);
        } else {
          this.$set(dataList[i], 'showEdit', false);
        }
      }
    },


    /**
     * 子任务回调
     */
    handleSubTasksBlock: function handleSubTasksBlock(data, item) {
      if (data.type == 'edit') {
        this.$set(item, 'showEdit', false);
      } else if (data.type == 'add') {
        this.addSubtasks = true;
        if (data.result == 'success') {
          this.$emit('on-handle', {
            type: 'change-sub-task',
            value: {
              subdonecount: this.subTaskComplete,
              allcount: this.taskData.subTaskList.length
            },
            index: this.detailIndex,
            section: this.detailSection
          });
        } else {
          this.$emit('on-handle', {
            type: 'change-sub-task',
            value: {
              subdonecount: this.subTaskComplete,
              allcount: this.taskData.subTaskList.length
            },
            index: this.detailIndex,
            section: this.detailSection
          });
        }
      } else if (data.type == 'cancel') {
        if (item) {
          this.$set(item, 'showEdit', false);
        } else {
          this.addSubtasks = true;
        }
      }
    },


    /**
     * 删除截止时间
     */
    deleteTimeTop: function deleteTimeTop() {
      var _this21 = this;

      workTaskTimeSetAPI({
        work_id: this.workId,
        task_id: this.id,
        stop_time: ''
      }).then(function (res) {
        _this21.$set(_this21.taskData, 'stop_time', '');
        _this21.$emit('on-handle', {
          type: 'stop-time',
          index: _this21.detailIndex,
          section: _this21.detailSection
        });
      }).catch(function () {});
    },


    /**
     * 激活任务
     */
    activateTask: function activateTask() {
      var _this22 = this;

      this.loading = true;
      workTaskRecoverAPI({ task_id: this.taskData.task_id, work_id: this.workId }).then(function (res) {
        _this22.loading = false;
        _this22.$emit('on-handle', {
          type: 'activate-task',
          index: _this22.detailIndex,
          section: _this22.detailSection
        });
        _this22.closeBtn();
      }).catch(function () {
        _this22.loading = false;
      });
    },


    /**
     * 激活任务
     */
    recoverTask: function recoverTask() {
      var _this23 = this;

      this.loading = true;
      workTrashRecoverAPI({ task_id: this.taskData.task_id, work_id: this.workId }).then(function (res) {
        _this23.loading = false;
        _this23.$message.success('恢复成功');
        _this23.$emit('on-handle', {
          type: 'recover-task',
          index: _this23.detailIndex,
          section: _this23.detailSection
        });
        _this23.closeBtn();
      }).catch(function () {
        _this23.loading = false;
      });
    },


    /**
     * 激活任务
     */
    thoroughDeleteTask: function thoroughDeleteTask() {
      var _this24 = this;

      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this24.loading = true;
        workTrashDeleteAPI({ task_id: _this24.taskData.task_id, work_id: _this24.workId }).then(function (res) {
          _this24.loading = false;
          _this24.$emit('on-handle', {
            type: 'thorough-delete-task',
            index: _this24.detailIndex,
            section: _this24.detailSection
          });
          _this24.closeBtn();
        }).catch(function () {
          _this24.loading = false;
        });
      }).catch(function () {
        _this24.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },


    /**
     * 任务头部操作
     */
    morkDropdownClick: function morkDropdownClick(command) {
      this.moreDelete();
    },


    /**
     * 关闭页面
     */
    hideView: function hideView() {
      this.$emit('close');
      this.$emit('hide-view');
    },


    /**
     * 日志评论
     */

    closeOtherReply: function closeOtherReply(flag) {
      if (!flag && this.$refs.comment_list) {
        this.$refs.comment_list.closeReply();
      }
    }
  }
};